var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Offline'),_c('Topbar'),_c('Sidebar'),_c('div',{staticClass:"app-content content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content-wrapper-before"}),_c('div',{staticClass:"content-header row"}),_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }